/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-11-29 14:57:21
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-06 16:26:17
 */
import TIM from 'tim-js-sdk/tim-js-friendship.js'
import TIMUploadPlugin from 'tim-upload-plugin'

// 初始化 SDK 实例

const tim = TIM.create({
  SDKAppID: process.env.TX_SDKAPPID
})

window.setLogLevel = tim.setLogLevel

// 无日志级别
tim.setLogLevel(4)

// 注册 cos
tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin })
export default tim



// WEBPACK FOOTER //
// ./src/tim.js